import axios from "axios";

/**
 * Single axios instance for the NestJS backend.
 *
 *  - Base URL: <REACT_APP_API_URL>/api/v1
 *  - withCredentials so the HttpOnly `refresh_token` cookie set by /auth/admin/login is sent
 *    on subsequent refresh / logout calls.
 *  - Request interceptor attaches the admin JWT (set on /auth/admin/login) as a Bearer token.
 *  - 401 on a non-auth call → wipe local session and bounce to /login. There is no refresh
 *    flow for the admin token yet (the backend supports /auth/refresh; wire it in if/when
 *    we want longer-lived sessions).
 */

/**
 * Hardcoded to the production NestJS backend. Override via .env (`REACT_APP_API_URL`)
 * only for local development; the deployed build always points at backend-v2.
 */
const BASE_URL = "https://backend-v2.cadabams.com";


export const ACCESS_TOKEN_KEY = "uda2.accessToken";

export const api = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
  withCredentials: true,
});

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token) {
  if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token);
  else localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function clearAuthAndRedirect() {
  setAccessToken(null);
  localStorage.removeItem("uda2.user");
  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
}

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const isAuthCall = (error?.config?.url || "").includes("/auth/");
    if (status === 401 && !isAuthCall) {
      clearAuthAndRedirect();
    }
    return Promise.reject(error);
  },
);
